import { useContext } from 'react';
import { Alert, AlertTitle, Backdrop, CircularProgress } from '@mui/material';
import { InvestigationContext } from '@context/InvestigationContext';
import { LocalizationContext } from '@context/LocalizationContext';

export default function LoadingComponent() {
	const { isError, isLoading } = useContext(InvestigationContext);
	const { ErrorMessage } = useContext(LocalizationContext);

	// Return <></> if routes path is ctr
	if (window.location.pathname === '/ctr') return <></>;

	/* Loading spinner */
	if (isLoading) {
		return (
			<Backdrop open={true} sx={{ zIndex: '1000' }}>
				<CircularProgress />
			</Backdrop>
		);
	}

	/* Error message */
	if (isError) {
		<Alert severity="error">
			<AlertTitle>{ErrorMessage.NetworkError}</AlertTitle>
		</Alert>;
	}

	return <></>;
}
